export function defaultNewTask() {
    return {
        classification: "Amber",
        frequency: {
            period: "Unknown",
            interval: 0,
        },
        title: "New task",
        note: "",
        content: "",
        isHeader: false,
        unitOfMeasure: "Nr",
        skillSet: "1",
    }
}

export function defaultNewHeader() {
    return {
        classification: "Not Specified",
        frequency: {
            period: "Unknown",
            interval: 0,
        },
        title: "New header",
        isHeader: true,
        unitOfMeasure: "Not Specified",
        newHeader: true,
    }
}
